<template>
  <div class="components-container">
    <split-pane :min-percent="15" :default-percent="25" split="vertical">
      <template slot="paneL">
        <el-form ref="form" class="detail-page-form" :model="row || {}" label-width="auto">
          <div
            v-for="(item, index) in form"
            :key="index"
            class="detail-page-group"
          >
            <div v-if="item.title" class="detail-page-group-header">
              <div class="detail-page-group-title">
                <i class="title-decorate iconfont icon-decorate" />
                {{ $t(item.title) }}
              </div>
            </div>
            <div style="padding: 0 18px;">
              <ZlDetail
                :border="item.border"
                :data="row || {}"
                :row="item.row || { gutter: 20 }"
                :options="item.group"
              />
            </div>
          </div>
        </el-form>
      </template>
      <template slot="paneR">
        <IframeDetail :url="url" class="iframe-detail" />
      </template>
    </split-pane>
  </div>
</template>

<script>
import ZlDetail from '@/utils/detail/components/detail-page-list'
import IframeDetail from '@/components/iframe/iframe-detail'
import Detail from '@utils/detail'
import splitPane from 'vue-splitpane'

const detail = new Detail('contract.contract')
  .setSpan(24)
  .border(false)
  .title('formTitle.baseInfo')
  .add('contractNumber')
  .add('contractName')
  .add('contractType')
  .add('signDate')
  .add('startDate')
  .add('endDate')
  .add('notifyNumber')
  .add('jiaOrganization')
  .add('yiOrganization')
  .add('contractDesc')

export default {
  components: {
    ZlDetail,
    IframeDetail,
    splitPane
  },
  props: {
    // eslint-disable-next-line
    row: {},
  },
  computed: {
    form() {
      return detail.form
    },
    url() {
      return process.env.VUE_APP_CONTRACT_API + `/srmFile/getFile?fileId=${this.row.fileId}`
    }
  }
}
</script>

<style lang="scss" scoped>
.components-container {
  position: relative;
  height: 100vh;
  .detail-page {
    &-group-header {
      color: #757575;
      font-size: 13px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &-group-title {
      position: relative;
      margin: 0 -10px;
      display: inline-flex;
      align-items: center;
      .title-decorate {
        transform: scale(.7);
        color: #008EE3;
        margin-right: 2px;
      }
      .title-warning {
        background: #FFEDE1;
        color: #FA6400;
        border-radius:2px;
        font-size:12px;
        padding: 3px 8px;
        margin-left: 5px;
      }
    }
  }
}
</style>
